// Components==============
import { Stream } from '@cloudflare/stream-react';
import React from 'react';
// =========================

export default function Video({
    videoId,
    onEnded,
    videoRef,
}: {
    videoId: string;
    onEnded?: EventListener;
    videoRef: React.Ref;
}) {
    const videoIdOrSignedUrl = videoId;
    return (
        <div>
            <Stream
                controls
                src={videoIdOrSignedUrl}
                onEnded={onEnded || undefined}
                streamRef={videoRef || undefined}
            />
        </div>
    );
}
